import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen overflow-hidden bg-gray-200 font-sans" }
const _hoisted_2 = { class: "flex min-w-0 flex-1 flex-col overflow-hidden" }
const _hoisted_3 = { class: "p-3 sm:p-4 md:p-6 lg:p-8" }

import { nextTick, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import Header from './AppHeader.vue'
import Sidebar from './AppSidebar.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const route = useRoute()
const mainScrollRef = ref<HTMLElement | null>(null)

watch(
  () => route.fullPath,
  async () => {
    await nextTick()
    if (mainScrollRef.value) {
      mainScrollRef.value.scrollTop = 0
      mainScrollRef.value.scrollLeft = 0
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Sidebar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header),
      _createElementVNode("main", {
        ref_key: "mainScrollRef",
        ref: mainScrollRef,
        class: "min-w-0 flex-1 overflow-x-hidden overflow-y-auto bg-slate-50 relative"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 512)
    ]),
    _createVNode(_component_router_link, {
      to: "/select",
      class: "fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-blue-800 text-white shadow-lg transition-all hover:-translate-y-1 hover:bg-blue-700 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-blue-300 group",
      title: "Kembali ke Pilihan Aplikasi"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          class: "h-6 w-6 transition-transform group-hover:scale-110",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          })
        ], -1),
        _createElementVNode("span", { class: "pointer-events-none absolute bottom-[calc(100%+8px)] right-0 bg-slate-800 text-white text-[12px] font-medium px-3 py-1.5 rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200" }, " Pilihan Aplikasi ", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})